<script>
export default {
  name: 'TheObfuscatedLinksHandler',
  mounted () {
    document.querySelectorAll('[data-link]').forEach(link => {
      link.addEventListener('click', this.openEncodedLink);
    });
  },
  methods: {
    openEncodedLink (event) {
      const decodedUrl = decodeURIComponent(window.atob(event.currentTarget.getAttribute('data-link')));
      if (event.currentTarget.getAttribute('data-target') === '_blank' || event.ctrlKey) {
        const newWindow = window.open(decodedUrl, '_blank');
        return newWindow.focus();
      }
      if (event.currentTarget.getAttribute('data-turbolinks') === 'false') {
        return document.location.href = decodedUrl;
      }
      this.$turbolinks.visit(decodedUrl);
    },
  },
  render () {
    return {};
  },
};
</script>
